import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { CuentaAbonoResponse } from 'src/app/global/interfaces/cuenta-abono.response';



export abstract class CuentaAbonoServiceVM {

    abstract getCuentaAbono(): Observable<CuentaAbonoResponse>;

    abstract postCuentaAbono(cuentaBancariaForm: FormGroup): Observable<any>;

    abstract createForm(): FormGroup;

    abstract createFormPJ(): FormGroup;

    abstract bancos(): Observable<BancoResponse[]>;

    abstract saveForm(cuentaBancariaForm: FormGroup): Promise<any>;

    abstract loadForm(cuentaBancariaForm: FormGroup, precarga?: boolean, isPJ?: boolean): Promise<void>;

    abstract postCuentaAbonoPaso3(cuentaBancariaForm: FormGroup): Observable<any>;
}
